import { useMutation } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { type ExpenseItemFormSchema } from '@webapp/modules/expense/components/ExpenseLineItemDrawer'
import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'

interface MutateEditExpenseLineItemVariables {
  itemId: number
  expenseReportId: number
  item: ExpenseItemFormSchema
}

export const useMutateEditExpenseLineItem = () => {
  const mutation = useMutation<
    void,
    RepoError,
    MutateEditExpenseLineItemVariables
  >({
    mutationFn: ({ itemId, expenseReportId, item }) =>
      expenseRepository.updateItem(itemId, expenseReportId, item),
  })

  return {
    mutate: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error,
  }
}
